import { render, staticRenderFns } from "./SentimentRuleFilters.vue?vue&type=template&id=2c572e98&"
import script from "./SentimentRuleFilters.vue?vue&type=script&lang=js&"
export * from "./SentimentRuleFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports